module.exports = __webpack_public_path__ + "img/compact.7e85bdfd.png";